import { PaqueteDto } from "../../firebase/firestore/paquetes";
import FormPackage, { STEP_RESUMEN } from "../packages/FormPackage";
import Modal from "./Modal";

export default function ModalFormPackage({
  entity,
  isOpen,
  onClose,
  initialStep = 0,
}: {
  entity?: PaqueteDto;
  isOpen: boolean;
  onClose: () => void;
  /** Paso en el que se abre el wizard. `STEP_RESUMEN` para consultar el paquete. */
  initialStep?: number;
}) {
  const title =
    initialStep === STEP_RESUMEN
      ? "Detalles del paquete"
      : entity
      ? "Editar paquete"
      : "Crear paquete";

  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      title={title}
      showCloseButton
      content={
        <FormPackage
          onClose={onClose}
          entity={entity}
          initialStep={initialStep}
        />
      }
    />
  );
}
